import { MnoConfig } from '../types';

export const mtnGhanaConfig: MnoConfig = {
  id: 'mtn_gh',
  name: 'MTN Ghana',
  colors: {
    primary: '#0A69AE',  // Life blue
    secondary: '#FDCD01', // MTN Yellow (operator color)
  },
  countryCode: '233',
  phoneNumberMask: '00 000 0000', // Ghanaian phone format (9 digits)
  appUrl: 'https://mtn.gh.life.fun',
  locations: [
    "Ahafo",
    "Ashanti",
    "Bono",
    "Bono East",
    "Central",
    "Eastern",
    "Greater Accra",
    "North East",
    "Northern",
    "Oti",
    "Savannah",
    "Upper East",
    "Upper West",
    "Volta",
    "Western",
    "Western North",
  ],
};
